module.exports = __webpack_public_path__ + "static/media/postres_checked.70f65e76.svg";